import * as React from "react";
import type { SVGProps } from "react";
const SvgPersonStretching = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.038 8.45a2.78 2.78 0 0 0 4.742-1.96v-.71a2.78 2.78 0 1 0-5.56 0v.71a2.78 2.78 0 0 0 .818 1.96Zm1.41-3.222a.78.78 0 0 1 1.332.552v.71a.78.78 0 0 1-1.56 0v-.71a.78.78 0 0 1 .228-.552Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M20 15c-.12.001-.238-.02-.35-.06l-6.888-2.582L12.22 15H16a1 1 0 0 1 1 .8l1 5a1 1 0 0 1-.8 1.2H17a1 1 0 0 1-1-.8l-.82-4.2H11a1.001 1.001 0 0 1-.77-.37 1 1 0 0 1-.23-.83l.687-3.433L4.24 14a1.029 1.029 0 0 1-.48-2l8-2a1 1 0 0 1 .59 0l8 3a1.016 1.016 0 0 1-.35 2Z"
    />
    <path
      fill="currentColor"
      d="M4 22h4a1 1 0 0 0 .89-.55l1.5-3a1 1 0 1 0-1.78-.9L7.38 20H4a1 1 0 0 0 0 2Z"
    />
  </svg>
);
export default SvgPersonStretching;
